import { TEST_WEBINAR_MAX_DURATION_MINUTES, TEST_WEBINAR_MAX_VIEWERS } from '@core/types';
import { useTranslation } from 'react-i18next';
import { useTestWebinarDeleteOn } from '../../hooks/useTestWebinarDeleteOn';
import { Heading } from '../Heading';
import { WarningOutlined } from '../Icons';

/**
 * The warning card for a test webinar (spec §5.6), in the WebinarNotPublishedWarning shape: the
 * limits, and — when the planned start is known — the moment it is deleted (start + 24 h).
 */
export const TestWebinarNotice = ({ broadcastDateTime }: { broadcastDateTime?: string | null }) => {
    const { t } = useTranslation();
    // An empty or invalid date yields an empty string, never shown below.
    const deleteOn = useTestWebinarDeleteOn(broadcastDateTime);

    return (
        <div
            data-testid="test-webinar-notice"
            className="bg-white bg-side-warning bg-no-repeat rounded-lg flex flex-col items-start gap-1 mb-4 pl-6 md:pl-8 pr-4 md:pr-6 pt-4 pb-6 z-10"
        >
            <WarningOutlined classNames="w-10 fill-warning mb-2" />
            <Heading variant="h3">{t('Webinar.Test.Notice.Title')}</Heading>
            <p className="max-w-3xl mb-2">
                {t('Webinar.Test.Notice.Body', { maxDurationMinutes: TEST_WEBINAR_MAX_DURATION_MINUTES, maxViewers: TEST_WEBINAR_MAX_VIEWERS })}
            </p>
            {deleteOn && <p className="max-w-3xl mb-4">{t('Webinar.Test.Notice.DeleteOn', { deleteOn })}</p>}
        </div>
    );
};
